






























import { Component, Vue, Prop, Watch, Emit, Model } from 'vue-property-decorator';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import { periods, aggregate_periods } from '@/constants';

function getPeriodTree() {
  // Формируем структуру дерева периодов
  return [
    {
      id: 'year',
      label: 'Год',
      children: [
        { id: 'year', label: 'Год' }
      ]
    },
    {
      id: 'months',
      label: 'Месяцы',
      expanded: true,
      children: periods.map(m => ({ id: m, label: capitalizeFirst(m) }))
    },
    {
      id: 'growth',
      label: 'Нарастание',
      children: Object.keys(aggregate_periods)
        .filter(k => k.startsWith('growth'))
        .map(k => ({ id: k, label: aggregate_periods[k].display || k }))
    },
    {
      id: 'wane',
      label: 'Убывание',
      children: Object.keys(aggregate_periods)
        .filter(k => k.startsWith('wane'))
        .map(k => ({ id: k, label: aggregate_periods[k].display || k }))
    },
    {
      id: 'year_periods',
      label: 'Периоды года',
      children: Object.keys(aggregate_periods)
        .filter(k => !k.startsWith('growth') && !k.startsWith('decline'))
        .map(k => ({ id: k, label: aggregate_periods[k].display || k }))
    }
  ];
}

function capitalizeFirst(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

@Component({
  name: 'PeriodTreeSelect',
  components: {
    DxDropDownBox,
    DxTreeView
  }
})
export default class PeriodTreeSelect extends Vue {
  @Model('input', { type: Array, default: () => [] }) value!: string[];
  @Prop({ default: 'Выберите период' }) placeholder!: string;
  @Prop({ default: false }) disabled!: boolean;

  treeData: any[] = getPeriodTree();
  expandedKeys: string[] = ['months'];
  selectedKeys: string[] = [];

  get displayValue() {
    return this.selectedKeys;
  }
  set displayValue(val: string[]) {
    this.selectedKeys = val;
    this.$emit('input', val);
  }

  displayExpr(item: any) {
    if (!item) return '';
    if (Array.isArray(item)) {
      return item.map((id: string) => this.findLabelById(id)).join(', ');
    }
    return this.findLabelById(item);
  }

  findLabelById(id: string): string {
    const find = (nodes: any[]): string | null => {
      for (const node of nodes) {
        if (node.id === id) return node.label;
        if (node.children) {
          const res = find(node.children);
          if (res) return res;
        }
      }
      return null;
    };
    return find(this.treeData) || id;
  }

  @Watch('value', { immediate: true })
  onValueChanged(val: string[]) {
    this.selectedKeys = val || [];
  }

  onSelectionChanged(e: any) {
    this.selectedKeys = e.component.getSelectedNodeKeys();
    this.$emit('input', this.selectedKeys);
  }
}
